<template>
  <div class="modelThree">
    <el-container>
      <el-header height="auto">
        <!-- <home-header :logo="logo" :opacity="opacity"></home-header> -->

        <div class="banner">
          <div class="bannersearch">
            <search-andselect></search-andselect>
          </div>
          <el-carousel trigger="click" height="auto">
            <el-carousel-item
              :id="'item' + index"
              v-for="(item, index) in banner.list"
              :key="index"
            >
              <a class="bannerLink" :href="item.link_url">
                <img :src="item.photo1" alt />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-header>
      <el-main>
        <div class="container-three" style="width:1200px;margin:0 auto;">
          <div class="mainTop">
            <hot-topic :hot="hot"></hot-topic>
          </div>
        </div>
        <div class="containerBg" style="width:1200px;margin:0 auto;">
          <div class="mainBottom">
            <new-roll :label="label"></new-roll>
          </div>
        </div>
      </el-main>

      <people-footer v-if="showPeople"></people-footer>
      <el-footer height="316px" v-else-if="hidefooter">
        <home-footer></home-footer>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import searchAndselect from "../components/searchAndselect.vue";
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import homeHeader from "@/components/homeHeader.vue"; //顶部
import homeFooter from "../components/homeFooter.vue"; //底部
import peopleFooter from "../components/peopleFooter.vue"; //底部
import hotTopic from "../components/hotTopic.vue"; //热门专题
import newRoll from "../components/newRoll.vue"; //最新滚动
import adsearch from "../components/adSearch.vue"; //广告
import { mapGetters, mapActions } from "vuex";
import {
  getModuleInfo,
  getResource,
  getCategoryNode
} from "./../services/api.js";
export default {
  data() {
    return {
      opacity: "0.68",
      select: "",
      label: {
        id: "",
        list: []
      },
      banner: {
        id: "",
        list: [{ photo1: "" }]
      },
      hot: {
        id: "",
        list: []
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      }
    };
  },
  mounted() {
    this.getModuleInfo();
  },
  watch: {
    channel_id() {
      this.getModuleInfo();
    }
  },
  computed: {
    ...mapGetters([
      "webModels",
      "curModelInfo",
      "modelsInfo",
      "webID",
      "hidefooter",
      "isEnglish",
      "showPeople"
    ]),
    channel_id() {
      return this.curModelInfo.id;
    }
  },
  components: {
    homeHeader,
    homeFooter,
    hotTopic,
    newRoll,
    adsearch,
    homeFooterAd,
    searchAndselect,
    peopleFooter
  },
  methods: {
    async getHotsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    async getGroupsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },
    getSpecialShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["800x500"]) {
          return item.custom_index_image["800x500"];
        }
      }
      return item.index_image;
    },
    getSpecialShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["800x500"]) {
          return item.group_custom_index_image["800x500"];
        }
      }
      return item.group_index_image;
    },
    getCarouselShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1600x562"]) {
          return item.custom_index_image["1600x562"];
        }
      }
      return item.index_image;
    },
    getCarouselShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1600x562"]) {
          return item.group_custom_index_image["1600x562"];
        }
      }
      return item.group_index_image;
    },
    async getModuleInfo() {
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var label = this.webModels.module_data.find(item => {
            if (item.title == "标签") return item;
          });
          var banner = this.webModels.module_data.find(item => {
            if (item.title == "A轮播图") return item;
          });
          var hot = this.webModels.module_data.find(item => {
            if (item.title == "A热门专题") return item;
          });
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            channel_id: this.channel_id
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = label.id;
          getModuleInfo(data, {
            page: 1,
            // page_nums: label.rows_num,
            sort: "asc"
          }).then(res => {
            if (res.status_code == 1) {
              this.label = {
                id: label.id,
                list: res.data.list
              };
            }
          });
          data.module_id = banner.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: banner.rows_num
          }).then(async res => {
            if (res.status_code == 1) {
              this.banner = {
                id: banner.id,
                list: res.data.list
              };
              for (let i = 0; i < this.banner.list.length; i++) {
                let resul = await this.getGroupsDataByCategoryChangeV(
                  this.banner.list[i]
                );
                this.banner.list[i].photo1 = resul.photo1;
                this.banner.list[i].link_url = resul.link_url;
                this.banner.list[i].title = resul.title;
                this.$set(this.banner.list, i, this.banner.list[i]);
              }
            }
          });
          data.module_id = hot.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: hot.rows_num
          }).then(async res => {
            if (res.status_code == 1) {
              this.hot = {
                id: this.hot.id,
                list: res.data.list
              };
              for (let i = 0; i < this.hot.list.length; i++) {
                let resul = await this.getHotsDataByCategoryChangeV(
                  this.hot.list[i]
                );
                this.hot.list[i].photo1 = resul.photo1;
                this.hot.list[i].link_url = resul.link_url;
                this.hot.list[i].title = resul.title;

                this.$set(this.hot.list, i, this.hot.list[i]);
              }
            }
          });
        }
      }, 0);
    }
  }
};
</script>

<style lang="less">
.modelThree {
  min-height: 1000px;
  .el-header {
    .banner {
      width: 100%;
      height: auto;
      margin: 0 auto;
      position: relative;
      .bannersearch {
        width: 1200px;
        margin: 20px auto;
        position: absolute;
        z-index: 99;
        left: 0px;
        right: 0px;
        top: 50%;
        margin-top: -60px;
        // opacity: 0.8;
      }
      // margin-top: -70px;
      .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
      .el-carousel {
        .el-carousel__container {
          overflow: hidden;
          height: auto !important;
        }
      }
      .el-carousel__container {
        #item0 {
          position: relative !important;
        }
        .el-carousel-item {
          .bannerLink {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.modelThree {
  .el-header {
    padding: 0px;
    .homeHeader {
      z-index: 1000;
      .logo {
        height: 100%;
        width: 120px;
      }
      .nav {
        width: 294px;
        margin-right: 36px;
        .nav-content {
          display: flex;
          height: 20px;
          font-size: 14px;
          font-family: PingFang-SC-Medium;
          line-height: 20px;
          padding-top: 24px;
          justify-content: space-between;
          li {
            a {
              color: #484848;
            }
          }
        }
      }
      .search {
        width: 427px;
        height: 40px;
        margin-top: 14px;
        display: flex;
        .el-select {
          padding-right: 0;
          width: 130px;
        }
        .el-button {
          background-color: #f05941;
          color: #fff;
          padding: 0px;
          height: 40px;
          width: 40px;
          font-size: 20px;
        }
      }
      .loginBtn {
        position: absolute;
        top: 14px;
        right: 20px;
        width: 98px;
        height: 40px;
        background: rgba(240, 89, 65, 1);
        border-radius: 3px;
        .btnContent {
          height: 20px;
          width: 70px;
          margin-top: 10px;
          margin-left: 14px;
          display: flex;
          justify-content: space-between;
          color: #ffffff;
          a {
            color: #ffffff;
          }
        }
      }
    }
    .banner {
      overflow: hidden;
      .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
      .bannerLink {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .el-main {
    margin-top: 20px;
    overflow: hidden;
    .containerBg {
      width: 100%;
    }
    .mainTop {
      margin-bottom: 35px;
    }
  }
  .el-footer {
    background-color: #181a1a;
    position: relative;
    padding: 0px;
  }
  .container-three {
    // width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/modelThree.vue